export namespace AccountSocialTransferEnum {
  export enum FIND_TYPE {
    PHONE = 'PHONE',
    EMAIL = 'EMAIL',
    MOBILE = 'MOBILE',
    I_PIN = 'I_PIN'
  }

  export enum IDENTIFIER_TYPE {
    INVALID = 'INVALID',
    VALID = 'VALID'
  }

  export enum BIRTH_TYPE {
    INVALID = 'INVALID',
    CONFIRM = 'CONFIRM'
  }

  export enum PHONE_TYPE {
    INVALID = 'INVALID',
    VALID = 'VALID'
  }

  export enum PHONE_AUTH_SEND_TYPE {
    SEND = 'SEND',
  }

  export enum EMAIL_TYPE {
    INVALID = 'INVALID',
    VALID = 'VALID'
  }

  export enum EMAIL_AUTH_SEND_TYPE {
    SEND = 'SEND',
  }

  export enum AUTH_TYPE {
    TIMEOUT = 'TIMEOUT',
    NOT_EQUAL = 'NOT_EQUAL',
    CONFIRM = 'CONFIRM'
  }

  export enum PASSWORD_TYPE {
    BEFORE_PASSWORD_EQUAL = 'BEFORE_PASSWORD_EQUAL',
    NOT_EDIT = 'NOT_EDIT',
    INVALID = 'INVALID',
    CONTINUE = 'CONTINUE',
    PRIVACY_IN = 'PRIVACY_IN',
    CONFIRM = 'CONFIRM',
  }

  export enum PASSWORD_CONFIRM_TYPE {
    NOT_EQUAL = 'NOT_EQUAL',
    EQUAL = 'EQUAL'
  }

  export enum SNS_CODE {
    NORMAL = 'NORMAL',
    NAME_NORMAL = '기본',

    FACEBOOK = 'FACEBOOK',
    NAME_FACEBOOK = '페이스북',

    TWITTER = 'TWITTER',
    NAME_TWITTER = '트위터',

    CTN_KT = 'CTN_KT',
    NAME_CTN_KT = 'CTN-KT',

    CTN_LG = 'CTN_LG',
    NAME_CTN_LG = 'CTN-LG',

    CTN_HOME_BOY = 'CTN_HOME_BOY',
    NAME_CTN_HOME_BOY = 'CTN-홈보이',

    KAKAOTALK = 'KAKAOTALK',
    NAME_KAKAOTALK = '카카오톡',

    GENIE_HOME = 'GENIE_HOME',
    NAME_GENIE_HOME = '지니홈',

    MEDIA_PACK = 'MEDIA_PACK',
    NAME_MEDIA_PACK = '미디어팩',

    GIGA_GENIE = 'GIGA_GENIE',
    NAME_GIGA_GENIE = '기가지니',

    NAVER = 'NAVER',
    NAME_NAVER = '네이버',

    APPLE = 'APPLE',
    NAME_APPLE = '애플'
  }

  export enum QUALITY_CODE {
    REGULAR = 'REGULAR',
    NORMAL = 'NORMAL'
  }

  export enum STATUS_CODE {
    ACTIVE = 'ACTIVE',
    WAIT = 'WAIT',
    QUIT = 'QUIT',
    LEAVE = 'LEAVE',
    DORMANT = 'DORMANT'
  }

  export enum VALID_CODE {
    BEFORE_PASSWORD_EQUAL = 'BEFORE_PASSWORD_EQUAL',
    INCLUDE_IDENTIFIER = 'INCLUDE_IDENTIFIER',
    INCLUDE_PHONE = 'INCLUDE_PHONE',
    AVAILABLE = 'AVAILABLE'
  }

  export enum SVC_CODE {
    DI = 'DI',
    NAME_DI = '안드로이드',
    IV = 'IV',
    NAME_IV = '아이폰',
    W = 'W',
    NAME_W = '유선',
    MW = 'MW',
    NAME_MW = '무선',
    GI = 'GI',
    NAME_GI = '기가지니',
    AV = 'AV',
    NAME_AV = '안드로이드TV'
  }
}
